import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject, pipe } from 'rxjs';
import { resolveFileUrl } from 'mm-web-core/attachment/resolve-url';
import { map } from 'rxjs/operators';
import { defaultAttachment } from 'mm-web-core/attachment/attachment-constants';
import { NzModalService } from 'ng-zorro-antd/modal';
import { AttachmentViewerModelComponent } from './attachment-viewer-model/attachment-viewer-model.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'mm-attachment-viewer',
    templateUrl: './attachment-viewer.component.html',
    styleUrls: ['./attachment-viewer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AttachmentViewerComponent implements OnInit {

    @Input() showImageViewer: boolean = true;

    fileName$ = new BehaviorSubject<string>(undefined);
    fileUrl$ = this.fileName$.pipe(
      pipe(
        map(fileName => {
            if (fileName) {
                if (fileName.toLocaleLowerCase().includes('.xls') || fileName.toLocaleLowerCase().includes('.xlsx')) {
                    return defaultAttachment.excel;
                } else if (fileName.toLocaleLowerCase().includes('.doc') || fileName.toLocaleLowerCase().includes('.docx')) {
                    return defaultAttachment.word;
                } else if (fileName.toLocaleLowerCase().includes('.ppt') || fileName.toLocaleLowerCase().includes('.pptx')) {
                    return defaultAttachment.ppt;
                } else if (fileName.toLocaleLowerCase().includes('.txt')) {
                    return defaultAttachment.txt;
                } else if (fileName.toLocaleLowerCase().includes('.pdf') || fileName.toLocaleLowerCase().includes('.jpg') || fileName.toLocaleLowerCase().includes('.jpeg') || fileName.toLocaleLowerCase().includes('.png') || fileName.toLocaleLowerCase().includes('.bmp') || fileName.toLocaleLowerCase().includes('.gif')) {
                    return resolveFileUrl(fileName);
                } else if (fileName.toLocaleLowerCase().startsWith('data:image')) {
                    return fileName;
                } else {
                    return defaultAttachment.other;
                }
            } else {
                return defaultAttachment.other;
            }
            ;
        })
      )
    );

    constructor(private modal: NzModalService,  private translateService: TranslateService,) {
    }

    @Input()
    set fileName(_: string) {
        this.fileName$.next(_);

    }

    ngOnInit(): void {
    }

    showImage() {
        if (!this.showImageViewer) {
            return;
        }
        var url = '';
        this.fileUrl$.subscribe(res => url = res);
        const image = new Image();
        image.src = url;
        var modal = this.modal.create({
            nzTitle: this.translateService.instant('Common.ViewOrigianlPic') ,
            nzContent: AttachmentViewerModelComponent,
            nzWidth: (image.width < 500 ? 500 : image.width) + 48 + 6,
            nzComponentParams: {
                url: url,
            },
            nzFooter: [
                {
                    label: this.translateService.instant('Common.Close') ,
                    onClick: () => modal.destroy()
                }
            ]
        });
    }

}
